import React from 'react';
import { ItemCard } from '@leverege/ui-attributes';
import { connect } from 'react-redux';
import { Selection } from '@leverege/ui-redux';
function Card(props) {
  const {
    colorScale,
    tooltipData,
    rolloverModel,
    getContext
  } = props;
  const context = getContext([tooltipData.nearestDatum.datum[tooltipData.nearestDatum.key]]);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      color: 'black',
      '--color-nearestDatum': colorScale(tooltipData.nearestDatum.key)
    }
  }, /*#__PURE__*/React.createElement(ItemCard, {
    model: rolloverModel,
    context: context
  }));
}
export default connect((state, props) => {
  return {
    rolloverModel: props.getRolloverModel(),
    rollover: Selection.get(state, 'rollover')
  };
}, null, null, {
  forwardRef: true
})(Card);